import store from '@/store/index'

class ListTableHeaderLazyLoad {
  getAuditRecordMoreDetailsHeader () {
    return [
      { label: 'SECTION', template: '{primaryCode}', fieldKey: 'primaryCode', options: { primaryCode: store.getters.getAuditSectionKeyEnum } },
      { label: 'AUDIT REASON', template: '{secondaryCode}', fieldKey: 'secondaryCode', options: { secondaryCode: store.getters.getAuditReasonEnum } },
      { label: 'STATUS', template: '{status}', fieldKey: 'status', options: { status: store.getters.getAuditDetailsStatusEnum } }
    ]
  }
}

export { ListTableHeaderLazyLoad }
